import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonModule,
  DefaultImageModule,
  FitTextModule,
  FormFieldModule,
  TextsFilterComponent,
} from '@shared/components/games';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { EightReadingControllerComponent } from './eight-reading-controller/eight-reading-controller.component';
import { EightReadingCorrectAnswerPreviewComponent } from './eight-reading-preview/eight-reading-answer-preview/eight-reading-answer-preview.component';
import { EightReadingExamplePreviewComponent } from './eight-reading-preview/eight-reading-example-preview/eight-reading-example-preview.component';
import { EightReadingParametersPreviewComponent } from './eight-reading-preview/eight-reading-parameters-preview/eight-reading-parameters-preview.component';
import { EightReadingUserAnswerPreviewComponent } from './eight-reading-preview/eight-reading-user-answer-preview/eight-reading-user-answer-preview.component';
import { EightReadingSettingsComponent } from './eight-reading-settings/eight-reading-settings.component';
import { SharedModule } from '@games/speed-reading/shared/shared.module';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { FontParametersModule } from '@shared/components/games/font-parameters/font-parameters.module';
import { TextGamesSharedModule } from '@games/games-shared/text-games-shared.module';
import { MatTooltip } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    EightReadingControllerComponent,
    EightReadingSettingsComponent,
    EightReadingCorrectAnswerPreviewComponent,
    EightReadingExamplePreviewComponent,
    EightReadingParametersPreviewComponent,
    EightReadingUserAnswerPreviewComponent,
  ],
  exports: [
    EightReadingControllerComponent,
    EightReadingSettingsComponent,
    EightReadingCorrectAnswerPreviewComponent,
    EightReadingExamplePreviewComponent,
    EightReadingParametersPreviewComponent,
    EightReadingUserAnswerPreviewComponent,
    NgSelectModule,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FitTextModule,
    NgSelectModule,
    DefaultImageModule,
    TextsFilterComponent,
    SharedModule,
    TextGamesSharedModule,
    FontParametersModule,
    FormFieldModule,
    MatTooltip,
  ],
})
export class EightReadingModule {}
